import { useEffect, useRef, useState } from "react";
import { Stack, Box, Text, Tabs, TabList, Tab, TabPanels, TabPanel, Flex, Input, FormLabel, Select, Button, Textarea, FormErrorMessage, FormControl, HStack, Heading, VStack, Grid, GridItem, Spinner } from "@chakra-ui/react";
import 'services/Recruit/assets/css/CreateJobOpening/style.css';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { globalStyles } from "common/theme/styles";
import { Field, Formik, Form } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import ActionNavbar from "common/components/actionBar/ActionNavbar";
import { useDispatch, useSelector } from "react-redux";
import { getDepartments } from "common/redux/reducers/departmentSlice";
import { fetchUserData } from "common/redux/reducers/userSlice";
import { uploadAttachment } from "common/redux/reducers/attachmentSlice";
import { recruitConstant } from "services/Recruit/constant";
import { PanelSchema } from "services/Recruit/schema/panelSchema";
import { panelTabs } from "services/Recruit/data/panel.Data";
import SkillsSection from "services/Recruit/components/SkillsSection;";
import CustomDropdown from "services/Recruit/components/CustomDropdown/CustomDropdown";
import { timeSlots } from "services/Recruit/data/panel.Data";
import { totalExperienceOptions } from "services/Recruit/data/panel.Data";
import ReactSelect from "react-select"
import { requiredSkillsOptions } from "services/Recruit/data/dropdownData";
import { constant } from "common/constant";
import { totalExperienceRangeOptions } from "services/Recruit/data/dropdownData";
import { interviewAvailabilityOptions } from "services/Recruit/data/dropdownData";
import { toast } from "react-toastify";
import { getApi } from "common/services/api";
import { API_PATHS } from "common/services/apiPaths";
import { putApi } from "common/services/api";
import { cleanFormDataCandidate } from "common/utils/formDataCleanerCandidate";
import { postApi } from "common/services/api";
import { HasAccess } from "common/utils/accessUtils";
import { accessModuleTitles } from "common/constant";

const PanelCreate = ({ availability, experience, onAvailabilityChange, onExperienceChange }) => {
  const colors = globalStyles.colors;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const { users } = useSelector((state) => state.users);
  // const { addLoading } = useSelector((state) => state.candidates);
  const [addLoading, setAddLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [panelData, setPanelData] = useState(null);
  const [permission] = HasAccess([accessModuleTitles.Panels]);

  useEffect(() => {
    if (id) {
      const fetchPanelData = async () => {
        try {
          let result = await getApi(API_PATHS.RECRUITMENT_INDIVIDUAL_PANEL, id);
          setPanelData(result?.data);
        } catch (e) {
          toast.error(constant.somethingWrong);
        }
      };

      fetchPanelData()
    }
  }, [id])

  const addPanel = async (values, resetForm) => {
    try {
      if (values.skills.includes("Other") && values.customSkill) {
        values.skills = values.skills
          .filter((skill) => skill !== "Other")
          .concat(`Other-${values.customSkill.trim()}`);
      }
      setAddLoading(true)
      const response = await postApi("api/recruitment/panel", values)
      if (response.status === 200 || response.status === 201) {
        toast.success("Panel created successfully")
        resetForm()
        navigate("/recruitment/panels")
      }
    } catch (e) {
      toast.error(e?.response?.data?.message || constant.somethingWrong)
    } finally {
      setAddLoading(false)
    }
  }


  const EditData = async (values) => {
    try {
      if (values.skills.includes("Other") && values.customSkill) {
        values.skills = values.skills
          .filter((skill) => skill !== "Other")
          .concat(`Other-${values.customSkill.trim()}`);
      }
      setEditLoading(true);
      let response = await putApi(
        `${API_PATHS.RECRUITMENT_INDIVIDUAL_PANEL}${id}`,
        values
      );
      if (response.status === 200) {
        toast.success("Application updated successfully");
        navigate("/recruitment/panels");
      }
    } catch (e) {
      toast.error(constant.somethingWrong);
    } finally {
      setEditLoading(false);
    }
  };

  const handleTabChange = (index) => {
    setActiveTabIndex(index);
  };

  useEffect(() => {
    // dispatch(getDepartments());
    dispatch(fetchUserData());
  }, [dispatch]);

  return (
    <Box  >
      <ActionNavbar
        isCreatePage={true}
      />
      <Stack>
        <Box className="createJobOpening-container">
          <Box className='createJobOpening-mainContainer'>
            <Box className='createJobOpening-breadCrumb'>
              <ArrowBackIcon onClick={() => navigate("/recruitment/panels")} fontSize="20px" cursor={"pointer"} />
              <Text className='createJobOpening-pageTitle'>{recruitConstant.createPanel}</Text>
            </Box>
          </Box>

          <Formik
            enableReinitialize={true}
            initialValues={
              panelData
                ? {
                  ...panelData,
                  panelName: panelData.panelName._id || "",

                  skills:
                    typeof panelData.skills === "string"
                      ? panelData.skills
                        ? [panelData.skills]
                        : []
                      : Array.isArray(panelData.skills)
                        ? panelData.skills
                        : [],

                  totalExperienceRange:
                    typeof panelData.totalExperienceRange === "string" ? panelData.totalExperienceRange : "",

                  interviewAvailability:
                    typeof panelData.interviewAvailability === "string"
                      ? panelData.interviewAvailability
                        ? [panelData.interviewAvailability]
                        : []
                      : Array.isArray(panelData.interviewAvailability)
                        ? panelData.interviewAvailability
                        : [],
                  customSkill: "",
                }
                : {
                  panelName: "",
                  skills: [],
                  totalExperienceRange: "",
                  interviewAvailability: [],
                  customSkill: "",
                }
            }

            validationSchema={PanelSchema}
            onSubmit={(values, { resetForm, isValid, errors }) => {

              // FIXED: Custom cleaning that preserves attachment deletion logic
              const cleanedValues = { ...values };

              // Clean other fields but preserve attachment fields as-is
              const attachmentFields = ['resume', 'coverLetter'];
              const attachmentValues = {};

              // Store attachment values before cleaning
              attachmentFields.forEach(field => {
                attachmentValues[field] = cleanedValues[field];
              });

              // Clean the form data (this might remove empty strings)
              // const generalCleanedValues = cleanFormData(cleanedValues);
              const generalCleanedValues = cleanFormDataCandidate(cleanedValues);

              // Restore attachment values to preserve deletion logic
              attachmentFields.forEach(field => {
                generalCleanedValues[field] = attachmentValues[field];
              });

              if (id) {
                EditData(generalCleanedValues)
              } else {
                addPanel(cleanedValues, resetForm)
              }
            }}
          >
            {({ values, setFieldValue, handleSubmit, errors, dirty, isValid, }) => (
              <Form onSubmit={handleSubmit}>
                <Tabs index={activeTabIndex} onChange={handleTabChange} className="createJobOpening-tabsContainer" variant="unstyled" orientation="vertical">
                  {/* tab list  */}
                  <TabList w={'40%'} className="createJobOpening-tabListContainer">
                    {panelTabs.map(({ label, Icon }, index) => (
                      <Tab
                        className="createJobOpening-tabs"
                        key={index}
                        _selected={{
                          color: colors.cta['100'],
                          borderLeft: "2px solid",
                          borderColor: colors.cta['100'],
                        }}
                        _hover={{
                          color: colors.cta['100'],
                        }}
                        _focus={{ boxShadow: "none" }}
                        display="flex"
                        alignItems="center"
                        gap="8px"
                      >
                        <Icon size={20} />
                        {label}
                      </Tab>
                    ))}
                  </TabList>

                  {/* tab panels */}
                  <TabPanels w={'60%'} className="createJobOpening-tabsPanelContainer">
                    {/* job opening tab */}
                    <TabPanel className="createJobOpening-tabsPanel">
                      {/* <VStack spacing={4} align="stretch">
                          <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                            <GridItem colSpan={2}>
                              <FormControl isInvalid={errors.panelFullName && touched.panelFullName}>
                                <FormLabel>{recruitConstant.panelName}</FormLabel>
                                <Field
                                  as={Input}
                                  name={recruitConstant.panelFullName}
                                  placeholder={recruitConstant.enterPanelName}
                                />
                                <FormErrorMessage>{errors.panelFullName}</FormErrorMessage>
                              </FormControl>
                            </GridItem>

                            <Flex gap={'20px'}>
                              <Box w={'50%'}>
                                <FormLabel htmlFor="skills">{recruitConstant.skills}<span className="astrick">*</span></FormLabel>
                                <Field name="skills">
                                  {({ field, form, meta }) => {

                                    const value =
                                      typeof field.value === "string"
                                        ? field.value
                                          ? [field.value]
                                          : []
                                        : Array.isArray(field.value)
                                          ? field.value
                                          : []

                                    const options = requiredSkillsOptions.map(({ value, label }) => ({
                                      value,
                                      label: constant[label] || label,
                                    }))

                                    const selectedOptions = options.filter((option) => value.includes(option.value))

                                    return (
                                      <>
                                        <ReactSelect
                                          isMulti
                                          name={field.name}
                                          onBlur={() => form.setFieldTouched(field.name, true)}
                                          closeMenuOnSelect={false}
                                          value={selectedOptions}
                                          options={options}
                                          className="basic-multi-select"
                                          classNamePrefix="select"
                                          onChange={(selectedOptions) => {
                                            const selectedValues = selectedOptions
                                              ? selectedOptions.map((option) => option.value)
                                              : []
                                            form.setFieldValue(field.name, selectedValues)
                                          }}
                                          placeholder="Select skills..."
                                          menuPortalTarget={document.body}
                                          menuPosition="fixed"
                                          styles={{
                                            control: (provided) => ({
                                              ...provided,
                                              borderColor:
                                                meta.touched && meta.error ? colors.errorText : colors.borderColor,
                                            })
                                          }}
                                        />
                                        {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}


                                      </>
                                    )
                                  }}
                                </Field>
                              </Box>
                            </Flex>

                            <GridItem colSpan={1}>
                              <FormControl isInvalid={errors.totalExprience && touched.totalExprience}>
                                <FormLabel>{recruitConstant.totalExprience}</FormLabel>
                                <CustomDropdown options={totalExperienceOptions} value={experience} onChange={onExperienceChange} />
                                <FormErrorMessage>{errors.skills}</FormErrorMessage>
                              </FormControl>
                            </GridItem>
                            <GridItem colSpan={1}>
                              <FormControl isInvalid={errors.availability && touched.availability}>
                                <FormLabel>{recruitConstant.availability}</FormLabel>
                                <CustomDropdown options={timeSlots} value={availability} onChange={onAvailabilityChange} />
                                <FormErrorMessage>{errors.skills}</FormErrorMessage>
                              </FormControl>
                            </GridItem>
                          </Grid>

                          <Flex justifyContent="flex-end" mt={4} gap={3}>
                            <Button
                              variant="primary"
                              className="backBtn"
                              onClick={() => navigate("/recruitment/panels")}
                            >
                              {recruitConstant.back}
                            </Button>
                            <Button type="submit" colorScheme="purple" onClick={() => navigate("/recruitment/panels")}>
                              {id ? recruitConstant.update : recruitConstant.save}
                            </Button>
                          </Flex>
                        </VStack> */}

                      <Box className="createJobOpening-tabsPanelBody">
                        <Flex gap={'20px'}>
                          <Box w={'50%'}>
                            <FormLabel htmlFor="panelName">{recruitConstant.panelName}<span className="astrick">*</span></FormLabel>
                            <Field name="panelName">
                              {({ field, meta, form }) => {
                                const interviewerOptions =
                                  users?.length > 0
                                    ? users
                                      .filter(
                                        (user) =>
                                          Array.isArray(user.roles) &&
                                          user.roles.some((role) => role.roleName === "employee"),
                                      )
                                      .map((user) => ({
                                        value: user._id,
                                        label: user.firstName + " " + user.lastName,
                                      }))
                                    : []

                                // Find selected option based on field value (single _id string)
                                const selectedOption = interviewerOptions.find((option) =>
                                  option.value === field.value
                                ) || null

                                return (
                                  <>
                                    <ReactSelect
                                      isDisabled={!permission?.update}
                                      name={field.name}
                                      value={selectedOption}
                                      onBlur={() => form.setFieldTouched(field.name, true)}
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      options={interviewerOptions}
                                      className="basic-multi-select reactSelect"
                                      classNamePrefix="select"
                                      onChange={(selectedOption) => {
                                        // Store only the _id as a string, or empty string if cleared
                                        const selectedValue = selectedOption ? selectedOption.value : ""
                                        form.setFieldValue(field.name, selectedValue)
                                      }}
                                      placeholder={constant.selectInterviewer}
                                      isClearable
                                      isSearchable
                                      styles={{
                                        control: (provided) => ({
                                          ...provided,
                                          borderColor:
                                            meta.touched && meta.error ? colors.errorText : colors.borderColor,
                                        }),
                                      }}
                                    />
                                    {meta.touched && meta.error && (
                                      <Text color={colors.errorText}>{meta.error}</Text>
                                    )}
                                  </>
                                )
                              }}
                            </Field>
                          </Box>

                          <Box w={"50%"}>
                            <FormLabel htmlFor="skills">{recruitConstant.skills}<span className="astrick">*</span></FormLabel>
                            <Field name="skills">
                              {({ field, form, meta }) => {
                                const value = Array.isArray(field.value) ? field.value : [];

                                const optionsWithOther = [
                                  ...requiredSkillsOptions.filter(opt => opt.value !== "Other" && opt.value !== "others"),
                                  { label: "Other", value: "Other" },
                                ];

                                const isOtherSelected = value.some(v => v === "Other");
                                const customSkillText = form.values.customSkill || "";

                                const selectedOptions = value.map(v => {
                                  const found = optionsWithOther.find(o => o.value === v);
                                  return found ? found : { label: v, value: v }; // Custom skill case
                                });
                                const validateCustomSkill = async () => {
                                  try {
                                    await PanelSchema.validateAt("skills", {
                                      ...form.values,
                                      skills: value,
                                      customSkill: form.values.customSkill
                                    });

                                    return true;
                                  } catch (err) {
                                    return false;
                                  }
                                };

                                return (
                                  <>
                                    <ReactSelect
                                      isDisabled={!permission?.update}
                                      isMulti
                                      name={field.name}
                                      value={selectedOptions}
                                      onBlur={() => form.setFieldTouched(field.name, true)}
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      options={optionsWithOther}
                                      className="basic-multi-select reactSelect"
                                      classNamePrefix="select"
                                      closeMenuOnSelect={false}
                                      onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions
                                          ? selectedOptions.map(opt => opt.value)
                                          : [];
                                        form.setFieldValue(field.name, selectedValues);
                                      }}
                                      placeholder="Select skills..."
                                      styles={{
                                        control: (provided) => ({
                                          ...provided,
                                          borderColor: meta.touched && meta.error
                                            ? colors.errorText
                                            : colors.borderColor,
                                        }),
                                      }}
                                    />

                                    {isOtherSelected && (
                                      <Box mt={2}>
                                        <Input
                                          placeholder="Enter custom skill"
                                          value={customSkillText}
                                          autoFocus
                                          onChange={(e) => {
                                            const val = e.target.value;

                                            if (val.startsWith(" ")) return;
                                            form.setFieldValue("customSkill", val);
                                          }}
                                          onBlur={async () => {
                                            const trimmed = form.values.customSkill?.trim();
                                            if (!trimmed) return;

                                            const isValid = await validateCustomSkill();
                                            if (!isValid) return;

                                            const newSkills = value.filter(v => v !== "Other").concat(trimmed);
                                            form.setFieldValue("skills", newSkills);
                                            form.setFieldValue("customSkill", "");
                                          }}

                                          onKeyDown={async (e) => {
                                            if (e.key === "Enter") {
                                              e.preventDefault();
                                              const trimmed = form.values.customSkill?.trim();
                                              if (!trimmed) return;

                                              const isValid = await validateCustomSkill();
                                              if (!isValid) return;

                                              const newSkills = value.filter(v => v !== "Other").concat(trimmed);
                                              form.setFieldValue("skills", newSkills);
                                              form.setFieldValue("customSkill", "");
                                            }
                                          }}

                                        />
                                      </Box>
                                    )}

                                    {meta.touched && meta.error && (
                                      <Text color={colors.errorText}>{meta.error}</Text>
                                    )}
                                  </>
                                );
                              }}
                            </Field>
                          </Box>
                        </Flex>

                        <Flex gap={'20px'}>
                          <Box w={'50%'}>
                            <FormLabel htmlFor="totalExperienceRange">{recruitConstant.totalExperienceRange}<span className="astrick">*</span></FormLabel>
                            <Field name="totalExperienceRange">
                              {({ field, meta }) => (
                                <>
                                  <Select
                                    isDisabled={!permission?.update}
                                    {...field}
                                    // placeholder={recruitConstant.selectSource}
                                    defaultValue=""
                                    borderColor={meta.touched && meta.error ? constant.errorText : constant.borderColor}
                                  >
                                    <option selected hidden value="">{recruitConstant.selectTotalExpRange}</option>
                                    {
                                      totalExperienceRangeOptions.map((option, index) => (
                                        <option key={index} value={option.value}>
                                          {option.label}
                                        </option>
                                      ))}
                                  </Select>
                                  {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                </>
                              )}
                            </Field>
                          </Box>

                          <Box w={"50%"}>
                            <FormLabel htmlFor="interviewAvailability">{recruitConstant.interviewAvailability}<span className="astrick">*</span></FormLabel>
                            <Field name="interviewAvailability">
                              {({ field, form, meta }) => {

                                const value =
                                  typeof field.value === "string"
                                    ? field.value
                                      ? [field.value]
                                      : []
                                    : Array.isArray(field.value)
                                      ? field.value
                                      : []

                                const options = interviewAvailabilityOptions.map(({ value, label }) => ({
                                  value,
                                  label: constant[label] || label,
                                }))

                                const selectedOptions = options.filter((option) => value.includes(option.value))

                                return (
                                  <>
                                    <ReactSelect
                                      isDisabled={!permission?.update}
                                      isMulti
                                      name={field.name}
                                      onBlur={() => form.setFieldTouched(field.name, true)}
                                      closeMenuOnSelect={false}
                                      value={selectedOptions}
                                      options={options}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      onChange={(selectedOptions) => {
                                        const selectedValues = selectedOptions
                                          ? selectedOptions.map((option) => option.value)
                                          : []
                                        form.setFieldValue(field.name, selectedValues)
                                      }}
                                      placeholder={constant.selectInterviewAvailability}
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      styles={{
                                        control: (provided) => ({
                                          ...provided,
                                          borderColor:
                                            meta.touched && meta.error ? colors.errorText : colors.borderColor,
                                        })
                                      }}
                                    />
                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}


                                  </>
                                )
                              }}
                            </Field>
                          </Box>


                        </Flex>

                        <Box className="createJobOpening-tabsPanelFooter">
                          <Button className="theme-btn2 cancelBtn"
                            sx={{
                              textTransform: "capitalize",
                            }}
                            onClick={() => navigate("/recruitment/panels")}
                            variant="outline"
                            colorScheme={colors.error["100"]}
                            size="sm">{constant.cancel}</Button>
                          <Button
                            disabled={
                              addLoading ||
                              editLoading ||
                              !dirty ||
                              !isValid ||
                              !permission?.update // disable if user doesn't have update permission
                            }
                            className="nextBtn"
                            variant="primary"
                            type="submit"
                          >
                            {(addLoading || editLoading) ? <Spinner size="sm" /> : id ? constant.update : constant.save}
                          </Button>
                        </Box>
                      </Box>
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Form>
            )}
          </Formik>
        </Box>
      </Stack>
    </Box>
  );
};

export default PanelCreate;
